import React, { Component } from 'react'
import moment from 'moment'
import classNames from 'classnames'
import { Message } from '@axshealth/design-library'
import { Spinner, Breadcrumb, Image } from 'react-bootstrap'

import NewMsgImg from '../../../_assets/images/new-message.png'
import EndAction from './Components/EndAction';
import PatientCard from '../../../_components/Cards/PatientCard'
import Participant from '../Components/Participant';
import FollowAction from './Components/FollowAction';
import ReopenAction from './Components/ReopenAction';
import Participants from '../Components/Participants'
import SendLinkModal from '../Components/SendLinkModal'
import RenderProfile from '../../../_components/Profile';
import SendMessageChatBox from '../Components/SendMessageChatBox'
import SendAttachmentModal from '../Components/SendAttachmentModal'
import NotificationSettings from './Components/NotificationSettings';

import { history } from '../../../_helpers/history'
import { isValidURL } from '../../../_helpers/regex'
import { alertActions } from '../../../_actions/alert.actions'

import withMsgStreamService from './withMsgStreamService'

import './style.css'
import Online from './Components/Online'
import { Can } from '../../../_contexts/AbilitiesContext'

import Status from './Components/Status'

class MessageStream extends Component {
  constructor(props) {
    super(props)

    this.clearTimeout = false;

    this.state = {
      url: '',
      message: '',
      showLink: false,
      showFile: false,
      showClose: false,
      isSending: false,
      attachment: null,
      invalidURL: false,
      newMessage: false,
      invalidAttachment: false,
      participantNotified: false,

      messages: props.current.messages,
      isLoading: props.patient ? props.patient.isLoading : false,
      currentUser: props.currentUser,
      conversation: props.current.conversation,
      patient: props.current.conversation && props.current.conversation.patient ? props.current.conversation.patient : props.patient,
      participant: props.current.conversation ? props.current.conversation.participants.data.find(participant => participant.userId === props.currentUser.UserId) : false,
      participants: props.current.conversation ? props.current.conversation.participants.data.filter(participant => participant.userId !== props.currentUser.UserId): [],
      licensedUser: props.current.conversation && props.current.conversation.licensedUser ? props.current.conversation.licensedUser : false,
      staffUser: props.current.conversation && props.current.conversation.staffUser ?  props.current.conversation.staffUser : false
    }

    this.participantNotifiedName = null

    this.publishTyping = this.publishTyping.bind(this)
    this.handleURL = this.handleURL.bind(this)
    this.handleMessage = this.handleMessage.bind(this)
    this.handleAttachment = this.handleAttachment.bind(this)
    this.observeLastMessage = this.observeLastMessage.bind(this)
    this.handleScrollToBottom = this.handleScrollToBottom.bind(this)
    this.showParticipantNotified = this.showParticipantNotified.bind(this)
  }

  componentDidMount() {
    this.scrollTimeout = setTimeout(() => {
      this.handleScrollToBottom()
    }, 2000)
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimeout)
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        messages: this.props.current.messages,
        isLoading: this.props.patient ? this.props.patient.isLoading : false,
        currentUser: this.props.currentUser,
        conversation: this.props.current.conversation,
        patient: this.props.current.conversation && this.props.current.conversation.patient ? this.props.current.conversation.patient : this.props.patient,
        participant: this.props.current.conversation ? this.props.current.conversation.participants.data.find(participant => participant.userId === this.props.currentUser.UserId) : false,
        participants: this.props.current.conversation ? this.props.current.conversation.participants.data.filter(participant => participant.userId !== this.props.currentUser.UserId) : [],
        licensedUser: this.props.current.conversation && this.props.current.conversation.licensedUser ? this.props.current.conversation.licensedUser : false,
        staffUser: this.props.current.conversation && this.props.current.conversation.staffUser ? this.props.current.conversation.staffUser : false
      }, () => {
        this.showHasNewMessage(prevProps)
      })
    }
  }

  publishTyping(typing) {
    this.props.isTyping(this.state.currentUser, typing);
  }

  showParticipantNotified(participant) {
    this.participantNotifiedName = participant
    this.setState({ participantNotified: participant }, () => {
      setTimeout(() => {
        this.setState({ participantNotified: false }, () => this.participantNotifiedName = null)
      }, 2000);
    })
  }

  showHasNewMessage(prevProps) {
    const messagesLen = prevProps.current.messages.length
    const messagesPropLen = this.state.messages.length

    if (
      messagesLen !== messagesPropLen &&
      messagesLen !== 0 &&
      messagesPropLen !== 0
    ) {
      const lastMessage = this.state.messages[0]
      if (lastMessage.sentBy.id !== this.state.currentUser.UserId) {
        this.observeLastMessage()
      } else {
        setTimeout(() => {
          this.handleScrollToBottom('auto')
        }, 200);
      }
    }
  }

  observeLastMessage() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        const lastMessageIsVisible = entries[0].isIntersecting
        this.setState({ newMessage: !lastMessageIsVisible })

        if (lastMessageIsVisible) {
          observer.unobserve(entries[0].target);
          this.handleScrollToBottom()
        }
      },
      { 
        root: document.getElementById('message-container'),
        rootMargin: '0px 0px 200px 0px'
      }
    )
    observer.observe(document.querySelector('#message-container > div > div'))
  }

  handleScrollToBottom(behavior = 'smooth') {
    const scrollTarget = document.getElementById('message-container')
    if (scrollTarget) {
      scrollTarget.scrollTo({
        top: scrollTarget.scrollHeight,
        behavior: behavior
      })
    }
    this.setState({ newMessage: false })
  }

  handleAttachment() {
    if (!this.state.attachment) {
      this.setState({ invalidAttachment: true })
    } else {
      this.setState({ isSending: true, invalidAttachment: false })
      this.props.dispatch(alertActions.clear())

      this.props.sendAttachment(this.state.attachment[0])
        .catch(() => {
          this.props.dispatch(alertActions.error('Could not send file at this time. Please try again.'))
        })
        .then(() => {
          this.setState({ attachment: null, isSending: false, showFile: false })
        })
    }
  }

  handleURL() {
    this.setState({ invalidURL: false })

    if (!isValidURL(this.state.url)) {
      this.setState({ invalidURL: true })
    } else {
      this.setState({ isSending: true })
      this.props.dispatch(alertActions.clear())

      this.props.sendLink(this.state.url)
        .then(() => {
          this.setState({ url: '' })
        })
        .catch(() => {
          this.props.dispatch(alertActions.error('Could not send link at this time. Please try again.'))
        })
        .then(() => {
          this.setState({ isSending: false, showLink: false })
        });
    }
  }

  handleMessage() {
    this.setState({ isSending: true })

    this.props.dispatch(alertActions.clear())

    this.props.sendMessage(this.state.message)
      .then(() => {
        this.setState({ message: '' })
      })
      .catch(() => {
        this.props.dispatch(alertActions.error('Could not send message at this time. Please try again.'))
      })
      .then(() => {
        this.setState({ isSending: false })
      });
  }

  handleReadReceipt(message) {
    return (
      this.state.currentUser.UserId === message.sentBy.id && (
        <span>
          <span className='font-weight-bold px-2'>·</span>Sent
          {/* Patient Read <span className='text-success'>✔</span> */}
        </span>
      )
    )
  }

  render() {
    const {
      message,
      patient,
      messages,
      showLink,
      showFile,
      isSending,
      staffUser,
      licensedUser,
      currentUser,
      participant,
      conversation,
      participants,
    } = this.state

    const sendBtnStatus = classNames({
      'btn-success': message !== '',
      'btn-secondary': message === '',
      'no-click-events': isSending || message === ''
    })

    const newMessageBtn = classNames(
      'new-message-btn axs-rounded shadow bg-primary text-light', {
      'new-message-btn-show': this.state.newMessage,
    })

    const participantNotifiedAlert = classNames(
      'participant-notified-alert axs-rounded shadow bg-primary text-light', {
      'participant-notified-alert-show': this.state.participantNotified,
    })

    return <div className="axs-container-xxl mx-auto mt-3">
      {!patient ?
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
        :
        <>
          <div className="row">
            <div className="col">
              <Breadcrumb>
                <Breadcrumb.Item onClick={(e) => { e.preventDefault(); history.push("/messages") }}>Messages</Breadcrumb.Item>
                <Breadcrumb.Item active>View</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>

          <div className="row">
            <div className='col-3'>
              <PatientCard
                email={patient.email}
                gender={patient.sexAssignedAtBirth || patient.sex}
                lastName={patient.lastName}
                firstName={patient.firstName}
                profileUrl={patient.profile}
                dateOfBirth={patient.dateOfBirth}
                phoneNumber={patient.phoneNumber}
              />
            </div>

            <div className="col-6">
              <div className="row card border-0 axs-shadow axs-rounded">

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center" style={{ height: '50px' }}>
                    {conversation &&
                      <>
                        <Status conversation={conversation} />

                        <div className="d-flex flex-wrap">
                          { conversation.settings.showOnline && this.props.online.map(user => {
                            return <Online key={user.userId} user={user} />
                          })}
                        </div>

                        {participant && <NotificationSettings
                          shouldNotifyProp={participant && participant.notifications}
                          conversationId={conversation.id}
                        />}

                        {!participant && <FollowAction
                          conversationId={conversation.id}
                        />}
                      </>
                    }
                  </div>
                </div>

                <div className="col-12 px-0">
                  <div id='message-container' style={{ height: '500px', padding: '0 15px' }}>
                    {!conversation &&
                      <div className="d-flex flex-column justify-content-between">
                        <div>
                          <div className="media pt-3 pb-4">
                            <div className="media-body">
                              <h5 className="text-muted text-center m-0">Say hello to {`${patient.firstName} ${patient.lastName}`}!</h5>
                            </div>
                          </div>
                          <div className="media">
                            <div className="media-body text-center">
                              <Image width={400} src={NewMsgImg} />
                            </div>
                          </div>
                        </div>
                        <div className="media py-4">
                          <div className="media-body">
                            <p className="lead text-muted text-center m-0">Start the conversation by entering your message below</p>
                          </div>
                        </div>
                      </div>
                    }

                    {conversation && messages && messages.length > 0 &&
                      <div className="d-flex flex-column-reverse">
                        {messages.map((message, i) => {
                          return <Message
                            id={null}
                            key={message.id}
                            message={message}
                            readReceipt={this.handleReadReceipt(message)}
                            currentUser={currentUser.UserId}
                            showCarePlan={() => { }}
                            handleClickLink={(url) => window.open(url, '_blank')}
                            handleClickAttachment={(url) => window.open(url, '_blank')}
                            startTelehealthVideo={() => { }}
                          />
                        })}
                      </div>
                    }
                  </div>

                  <div className='d-flex justify-content-center'>
                    <div onClick={() => this.handleScrollToBottom()}
                      className={newMessageBtn}>
                      <i className="fas fa-comment"></i>&nbsp;New Message
                    </div>
                  </div>

                  <div className='d-flex justify-content-center'>
                    <div className={participantNotifiedAlert}>
                      <i className="fas fa-concierge-bell fa-sm"></i>&nbsp;{this.participantNotifiedName} has been notified
                    </div>
                  </div>
                </div>


                <div className="col-12">
                  {conversation && conversation.status === 'closed' && conversation.closedBy === undefined &&
                    <p className="text-center text-muted">This conversation has been closed.</p>
                  }

                  {conversation && conversation.status === 'closed' && conversation.closedBy &&
                    <p className="text-center text-muted">The message was closed by {conversation.closedBy.firstName} {conversation.closedBy.lastName}
                      &nbsp;on {moment.tz(conversation.closedAt.date, conversation.closedAt.timezone).local().format('LL [at] LT')}</p>
                  }

                  {conversation && conversation.status === 'open' &&
                    <div className="pb-3">
                      <SendMessageChatBox
                        isTyping={this.publishTyping}
                        message={message}
                        isSending={isSending}
                        sendBtnStatus={sendBtnStatus}
                        handleShowFile={() => this.setState({ showFile: true })}
                        handleShowLink={() => this.setState({ showLink: true })}
                        handleSetMessage={(e) => this.setState({ message: e.target.value })}
                        handleSendMessage={this.handleMessage}
                      />

                      <SendAttachmentModal
                        showFile={showFile}
                        isSending={isSending}
                        attachment={this.state.attachment}
                        invalidAttachment={this.state.invalidAttachment}
                        handleCancel={() => this.setState({ showFile: false, attachment: null })}
                        handleAttachment={this.handleAttachment}
                        handleSetAttachment={(attachment) => this.setState({ attachment })}
                      />

                      <SendLinkModal
                        URL={this.state.url}
                        showLink={showLink}
                        isSending={isSending}
                        invalidURL={this.state.invalidURL}
                        handleURL={this.handleURL}
                        handleSetURL={(e) => this.setState({ url: e.target.value })}
                        handleCancel={() => this.setState({ showLink: false })}
                      />
                    </div>
                  }

                  {!conversation &&
                    <div className="pb-3">
                      <SendMessageChatBox
                        isTyping={() => {}}
                        message={message}
                        isSending={isSending}
                        sendBtnStatus={sendBtnStatus}
                        handleShowFile={() => this.setState({ showFile: true })}
                        handleShowLink={() => this.setState({ showLink: true })}
                        handleSetMessage={(e) => this.setState({ message: e.target.value })}
                        handleSendMessage={this.handleMessage}
                      />

                      <SendAttachmentModal
                        showFile={showFile}
                        isSending={isSending}
                        attachment={this.state.attachment}
                        invalidAttachment={this.state.invalidAttachment}
                        handleCancel={() => this.setState({ showFile: false, attachment: null })}
                        handleAttachment={this.handleAttachment}
                        handleSetAttachment={(attachment) => this.setState({ attachment })}
                      />

                      <SendLinkModal
                        URL={this.state.url}
                        showLink={showLink}
                        isSending={isSending}
                        invalidURL={this.state.invalidURL}
                        handleURL={this.handleURL}
                        handleSetURL={(e) => this.setState({ url: e.target.value })}
                        handleCancel={() => this.setState({ showLink: false })}
                      />
                    </div>
                  }
                </div>
              </div>
            </div>

            <div className='col-3'>
              {conversation &&
                <>
                  <Participants
                    licensedUser={licensedUser}
                    staffUser={staffUser}
                    participant={participant}
                    participants={participants}
                    conversation={conversation}
                    shouldNotify={participant && participant.notifications}
                    showParticipantNotified={this.showParticipantNotified}
                  />

                  <br />

                  {conversation.status === 'open' &&
                    <Can I="close" a="messages">
                      <EndAction conversationId={conversation.id} handleClose={() => this.props.loadConversation()} />
                    </Can>
                  }
                  {conversation.status === 'closed' &&
                    <Can I="reopen" a="messages">
                      <ReopenAction conversationId={conversation.id} handleReopen={() => this.props.loadConversation()} />
                    </Can>
                  }
                </>
              }

              {!conversation && currentUser &&
                <>
                  <RenderProfile
                    name={`${currentUser.FirstName} ${currentUser.LastName}`}
                    type={currentUser.UserType.Name}
                    profileUrl={currentUser.ProfileUrl}
                  />

                  <br />

                  <div className="row my-4">
                    <div className="col">
                      <h3 className='m-0 font-weight-light'>Participants</h3>
                    </div>
                  </div>

                  <div className="row">
                    <div className='col'>
                      <Participant
                        name='Yourself'
                        profileUrl={currentUser.ProfileUrl}
                        lastReadAt={null}
                        hasMessages={false}
                        notifications={true}
                      />
                    </div>
                  </div>
                </>
              }
            </div>
          </div>
        </>
      }
    </div>
  }
}

export default withMsgStreamService(MessageStream)